import { render, staticRenderFns } from "./Pessoa.vue?vue&type=template&id=a908a4ba&scoped=true&lang=pug"
import script from "./Pessoa.vue?vue&type=script&lang=js"
export * from "./Pessoa.vue?vue&type=script&lang=js"
import style0 from "./Pessoa.vue?vue&type=style&index=0&id=a908a4ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a908a4ba",
  null
  
)

export default component.exports